import React from "react";
import { DetailSidePanel } from "../DetailSidePanel";
import { useReplaceSidePanel } from "../SidePanel";
import { ApproveButton, DeleteButton } from "./DeleteAndApproveButtons";
import { flightFromAiSidePanelApiKey } from "./flightFromAiSidePanelConstants";
import { FlightFromAiSidePanelDetails } from "./FlightFromAiSidePanelDetails";

export interface FlightFromAiSidePanelProps {
  extractedFlightId: number
  trigger: JSX.Element
}

const getFlightFromAiSidePanelId = (extractedFlightId: number) =>
  `${flightFromAiSidePanelApiKey}-side-${extractedFlightId}`;

interface FlightFromAiDetailSidePanelProps {
  extractedFlightId: number
  trigger?: JSX.Element
  skipSidePanelBase?: boolean
}

const FlightFromAiDetailSidePanel = (props: FlightFromAiDetailSidePanelProps) => {
  const replaceFlightFromAiSidePanel = useReplaceFlightFromAiSidePanel();

  return <DetailSidePanel
    apiCall={() => window.CoreApi.Extractor.GetExtractedFlight(props.extractedFlightId)}
    apiKey={flightFromAiSidePanelApiKey}
    entityId={props.extractedFlightId}
    title="Flight from AI"
    footerContent={data => <>
      <DeleteButton
        extractedFlightId={data.extractedFlightId}
        extractorSessionId={data.extractorSessionId}
        replaceFlightFromAiSidePanel={replaceFlightFromAiSidePanel}
      />
      {data.lifeCycle === "readyForApproval" && <ApproveButton
        extractedFlightId={data.extractedFlightId}
        extractorSessionId={data.extractorSessionId}
        replaceFlightFromAiSidePanel={replaceFlightFromAiSidePanel}
      />}
    </>}
    trigger={props.trigger}
    skipSidePanelBase={props.skipSidePanelBase}
  >
    {(data) => <FlightFromAiSidePanelDetails
      data={data}
    />}
  </DetailSidePanel>
};

export const useReplaceFlightFromAiSidePanel = () => {
  const replaceSidePanel = useReplaceSidePanel();

  const replaceFlightFromAiSidePanel = React.useCallback((extractedFlightId: number) => {
    replaceSidePanel(
      <FlightFromAiDetailSidePanel
        extractedFlightId={extractedFlightId}
        skipSidePanelBase
      />,
      getFlightFromAiSidePanelId(extractedFlightId)
    );
  }, [replaceSidePanel]);

  return replaceFlightFromAiSidePanel;
}

export const FlightFromAiSidePanel = (props: FlightFromAiSidePanelProps) => {
  return <FlightFromAiDetailSidePanel
    extractedFlightId={props.extractedFlightId}
    trigger={props.trigger}
  />;
};
